var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-group-item animate__animated" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-5 col-md-3 list-group-item-image" },
        [
          _c(
            "div",
            { staticClass: "list-image" },
            [
              _vm.shipData.bilder[0] &&
              _vm.getLargestAvailableImage(
                _vm.shipData.bilder[0].filenames,
                "16x9"
              )
                ? _c("responsive-image", {
                    attrs: {
                      src: _vm.getLargestAvailableImage(
                        _vm.shipData.bilder[0].filenames,
                        "16x9"
                      ),
                      "src-xs": _vm.shipData.bilder.img800_16x9,
                      "src-sm": _vm.shipData.bilder.img400_16x9,
                      "src-md": _vm.shipData.bilder.img400_16x9,
                      "src-lg": _vm.shipData.bilder.img400_16x9,
                      "fixed-aspect-ratio": 16 / 9,
                      "img-class": "ship-preview-picture img-responsive",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-7 col-md-5 list-group-item-content" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.shipData.bezeichnung))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.shipData.untertitel))]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-xs-12 col-sm-7 col-md-4 list-group-item-button pull-right",
        },
        [
          _c("a", { attrs: { href: _vm.detailUrl, target: _vm.target } }, [
            _c("span", { staticClass: "btn btn-primary btn-arrow" }, [
              _vm._v("Details anzeigen"),
            ]),
          ]),
          _vm._v(" "),
          _vm.showCurrentTravelsLink
            ? _c("a", { attrs: { href: _vm.travelsUrl, target: _vm.target } }, [
                _c(
                  "span",
                  {
                    staticClass: "btn btn-primary btn-arrow",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [_vm._v("Aktuelle Reisen")]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }